const responseCode = {
  HTTP_OK: 200,
  HTTP_CREATED: 201,
  HTTP_ACCEPTED: 202,
  HTTP_NO_CONTENT: 204,
  HTTP_MULTI_STATUS: 207,
  HTTP_BAD_REQUEST: 400,
  HTTP_UNAUTHORIZED: 401,
  HTTP_ACCESS_DENIED: 403,
  HTTP_NOT_FOUND: 404,
  HTTP_CONFLICT: 409,
  HTTP_UNKNOWN_SERVER_EXCEPTION: 500,
};

module.exports = { responseCode };
